import unionBy from 'lodash/unionBy';
import SpotUtils from 'spot-utils';
import {
    GET_SPOTS_RADIAL,
    GET_SPOTS_TILED,
    RADIAL_SPOTS_INCREMENT,
    TILED_SPOTS_INCREMENT,
    CLEAR_SPOTS_DATA
} from './spots-actions';
import {getStore} from '../store';

const initialState = {
    isPending: true,
    data: [],
    error: null
};

export default function spots(state = initialState, {type, payload}) {
    switch (type) {
        case `${GET_SPOTS_RADIAL}_PENDING`: {
            return initialState;
        }

        case `${GET_SPOTS_RADIAL}_FULFILLED`: {
            return {
                ...state,
                isPending: false
            };
        }

        case `${GET_SPOTS_RADIAL}_REJECTED`: {
            return{
                ...state,
                isPending: false,
                error: payload
            };
        }

        case RADIAL_SPOTS_INCREMENT: {
            return {
                ...state,
                data: [
                    ...state.data,
                    ...SpotUtils.prepareGroup(payload, getStore().getState().search.data.params)
                ]
            };
        }

        case `${GET_SPOTS_TILED}_PENDING`: {
            return {
                ...state,
                isPending: true
            };
        }

        case `${GET_SPOTS_TILED}_FULFILLED`: {
            return {
                ...state,
                isPending: false
            };
        }

        case `${GET_SPOTS_TILED}_REJECTED`: {
            return {
                ...state,
                isPending: false,
                error: payload
            };
        }

        case TILED_SPOTS_INCREMENT: {
            return {
                ...state,
                data: unionBy(
                    state.data,
                    SpotUtils.prepareGroup(payload, getStore().getState().search.data.params),
                    'parking_spot_id'
                )
            };
        }

        case CLEAR_SPOTS_DATA: {
            return {
                ...initialState,
                isPending: false,
                data: []
            };
        }

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./widget/src/js/common/spots-reducer.js